<template>
	<b-card no-body>
		<b-card-header class="p-2">
			<h4 class="mb-0">Customer Documents</h4>
		</b-card-header>
		<div class="p-3">
			<b-row>
				<b-col lg="12">
					<UploadFiles @addFiles="addFiles" />
				</b-col>
				<b-col lg="12" v-if="!_gHlp.isEmpty(newAttachments)">
					<div class="card-table-simple mb-3">
						<b-table-simple responsive class="mb-0">
							<b-thead>
								<b-tr>
									<b-th>Name</b-th>
									<b-th>Doc Type</b-th>
									<b-th>Remarks</b-th>
									<b-th></b-th>
								</b-tr>
							</b-thead>
							<b-tbody>
								<b-tr v-for="(data, index) in newAttachments" :key="index">
									<b-td>{{ data.file.upload.filename }}</b-td>
									<b-td>
										<b-form-select v-model="data.attachment_category_id">
											<b-form-select-option :value="''">select doc type</b-form-select-option>
											<b-form-select-option v-for="item in attachmentCategories" :key="item.attachment_category_id"
												:value="item.attachment_category_id">
												{{ item.name }}
											</b-form-select-option>
										</b-form-select>
									</b-td>
									<b-td>
										<b-form-input v-model="newAttachments[index].remark" placeholder="Remark">
										</b-form-input>
									</b-td>
									<b-td class="text-danger">
										<svg v-if="!viewOnlyAttachmentIds.includes(data.attachment_id)" @click="removeFile(data)" xmlns="http://www.w3.org/2000/svg" class="text-danger cursor-pointer"
											width="14" height="18" viewBox="0 0 448 512">
											<path fill="currentColor"
												d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16" />
										</svg>
									</b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</div>
					<el-button class="bg-primary text-white ml-auto" @click.prevent="uploadAll()" :loading="is_loading_btn">Upload
						All</el-button>
				</b-col>
			</b-row>
		</div>
		<b-card-header class="p-2">
			<h4 class="mb-0">Uploaded Documents</h4>
		</b-card-header>
		<b-card-body class="p-3">
			<!-- FILTERS -->
			<b-row class="d-flex align-items-start mb-3">
				<!-- LEFT SECTION -->
				<b-col cols="auto">
					<div class="d-flex align-items-center">
						<div class="p-0 mr-2">
							<el-input placeholder="Search by text" v-model="filters.filename" v-on:input="debouncedHandler($event)">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</div>
						<div class="p-0 mr-2">
							<el-select v-model="filters.attachment_category_id" collapse-tags placeholder="Filter by Category"
								@change="getListing">
								<el-option :key="-1" label="All Document Type" :value="''">
								</el-option>
								<el-option v-for="item in attachmentCategories" :key="item.attachment_category_id" :label="item.name"
									:value="item.attachment_category_id">
								</el-option>
							</el-select>
						</div>
						<div class="p-0 mr-2">
							<el-date-picker v-model="filters.created_at" value-format="yyyy-MM-dd" type="date" @change="getListing"
								placeholder="Filter Upload Date"></el-date-picker>
						</div>
					</div>
				</b-col>

				<!-- RIGHT SECTION -->
				<b-col cols="auto" class="ml-auto mx-2">
					<b-row class="d-flex align-items-center">
						<!-- <b-col cols="auto">
							<el-button class="px-3 py-2 mb-2 mb-md-0" type="gray" plain
								@click="$refs.drawer_filter_disbursement.show()">
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
									<path fill="currentColor"
										d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z" />
								</svg>
								Filters
							</el-button>
						</b-col> -->
					</b-row>
				</b-col>

			</b-row>

			<div class="card-table-simple" v-loading="is_loading_table">
				<b-table-simple responsive class="mb-0">
					<b-thead>
						<b-tr>
							<b-th>Name</b-th>
							<b-th>Doc Type</b-th>
							<b-th>Remarks</b-th>
							<b-th>Uploaded by</b-th>
							<b-th>Date</b-th>
							<b-th></b-th>
						</b-tr>
					</b-thead>
					<b-tbody v-if="!_gHlp.isEmpty(tableData)">
						<b-tr v-for="(data, index) in tableData" :key="index">
							<b-td @click="$refs.preview_modal.preview(data.url, data.original_filename)"
								class="cursor-pointer text-primary font-weight-500">{{ data.filename }}</b-td>
							<b-td>{{ !_gHlp.isEmpty(data.attachment_category) ? data.attachment_category.name : '-' }}</b-td>
							<b-td>{{ data.remark || '-' }}</b-td>
							<b-td>{{ data.created_by_detail.name }}</b-td>
							<b-td>{{ data.created_at | dateFormatString }}</b-td>
							<b-td class="text-danger">
								<svg @click="deleteFile(data)" xmlns="http://www.w3.org/2000/svg" class="cursor-pointer" width="12"
									height="16" viewBox="0 0 448 512" v-if="!viewOnlyAttachmentIds.includes(data.attachment_id)">
									<path fill="currentColor"
										d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
								</svg>
							</b-td>
						</b-tr>
					</b-tbody>
					<b-tbody v-else>
						<b-tr>
							<b-td :colspan="6">No Attachment</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</div>
		</b-card-body>
		<PreviewModal ref="preview_modal"></PreviewModal>
	</b-card>
</template>
<script>
import { Button, Option, Select, DatePicker, Table, TableColumn, } from 'element-ui'
import { swal } from '@/assets/js/httpImports.js';
import _ from 'lodash';
import UploadFiles from '@/views/Widgets/UploadFiles'
import PreviewModal from '@/components/Modal/PreviewModal';
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { useCustomerStore } from '@/stores/customerStore';
import { useAttachmentStore } from '@/stores/attachmentStore';

export default {
	components: {
		UploadFiles,
		PreviewModal,
		[Button.name]: Button,
		[Option.name]: Option,
		[Select.name]: Select,
		[DatePicker.name]: DatePicker,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
			is_loading_table: false,
			is_loading_btn: false,
			newAttachments: [],
			// remarks: '',
			// doc_type: '',
			docTypeList: [
				{
					value: 'Payslip',
					label: 'Payslip'
				}
			],
			tableData: [],
			viewOnlyAttachmentIds: [],
			debouncedHandler: '',
			filters: {
				filename: '',
				created_at: '',
				attachment_category_id: ''
			}
		}
	},
	created() {
		this.listAttachmentCategories();
		this.getListing();
		this.viewOnlyAttachmentIds = !_gHlp.isEmpty(this.activeCustomerInv) ? this.activeCustomerInv.src_attachment_ids : [];
		this.debouncedHandler = _.debounce((val) => {
			if (val.length == 0 || val.length >= 3 || typeof val == 'number') {
				this.getListing();
			}
		}, 500);
	},
	beforeDestroy() {
		this.clearComponent()
	},
	beforeUnmount(){
		this.clearComponent()
	},
	watch: {
		activeCustomerInv: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					this.viewOnlyAttachmentIds = newVal.src_attachment_ids
				}
			}
		}
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeCase']),
		...mapState(useCustomerStore, ['activeCustomer', 'activeCustomerInv']),
		...mapState(useAttachmentStore, ['attachmentCategories']),
	},
	methods: {
		...mapActions(useAttachmentStore, ['getAttachmentList', 'detailAttachment', 'uploadAttachment', 'deleteAttachment', 'listAttachmentCategories']),
		clearComponent(){
			this.is_loading_table = false
			this.is_loading_btn = false
			this.newAttachments = []
			this.docTypeList = [
				{
					value: 'Payslip',
					label: 'Payslip'
				}
			]
			this.tableData = []
			this.viewOnlyAttachmentIds = []
			this.debouncedHandler = ''
			this.filters = {
				filename: '',
				created_at: '',
				attachment_category_id: ''
			}
		},
		getFilters() {
			let filtered = {};
			let obj = this.filters;
			Object.keys(obj).forEach(key => {
				if (!_gHlp.isEmpty(obj[key])) {
					filtered[key] = obj[key];
				}
			});
			return filtered;
		},
		getListing() {
			this.is_loading_table = true;
			this.tableData = [];
			let reqs = [];

			//REQ ORIGNAL SOURCE CUSTOMER DOC (sas_im2u_id)
			let filtered = this.getFilters();
			let params = {}
			if (!_gHlp.isEmpty(this.activeCustomerInv)) {
				//VIEWONLY ATTACHMENTS
				if (!_gHlp.isEmpty(this.activeCustomerInv.sas_im2u_id)) {
					params = { ...filtered, ...{ owner_id: this.activeCustomerInv.sas_im2u_id, owner_type: 'customer' } }
					reqs.push(this.getAttachmentList(params).then(resp => {
						if (!_gHlp.isEmpty(resp.data)) {
							for (let i = 0; i < resp.data.length; i++) {
								const att = resp.data[i];
								if (this.viewOnlyAttachmentIds.includes(att.attachment_id)) {
									this.tableData.push(att);
								}
							}
						}
					}));
				}
				if (!_gHlp.isEmpty(this.activeCustomerInv.psal_id)) {
					params = { ...filtered, ...{ owner_id: this.activeCustomerInv.psal_id, owner_type: 'proposal' } }
					reqs.push(this.getAttachmentList(params).then(resp => {
						if (!_gHlp.isEmpty(resp.data)) {
							for (let i = 0; i < resp.data.length; i++) {
								const att = resp.data[i];
								if (this.viewOnlyAttachmentIds.includes(att.attachment_id)) {
									this.tableData.push(att);
								}
							}
						}
					}));
				}

				//EDITABE ATTACHMENTS
				if (!_gHlp.isEmpty(this.activeCustomerInv.im2u_id)) {
					params = { ...filtered, ...{ owner_id: this.activeCustomerInv.im2u_id, owner_type: 'customer' } }
					reqs.push(this.getAttachmentList(params).then(resp => {
						if (!_gHlp.isEmpty(resp.data)) {
							for (let i = 0; i < resp.data.length; i++) {
								const att = resp.data[i];
								this.tableData.push(att);
							}
						}
					}));
				}
			}

			if (!_gHlp.isEmpty(reqs)) {
				Promise.all(reqs)
					.then(res => {
						_gNotif.notifySuccess('<b>Document</b> - Fetch Successfully.')
						this.is_loading_table = false
					})
					.catch(e => {
						this.is_loading_table = false
						_gNotif.errorFunction(e)
					})
			}else{
				this.is_loading_table = false
			}
		},
		addFiles(items) {
			let owner_type = 'customer';
			let owner_id = this.activeCustomer.customer_id;
			let tags = 'lms_' + this.activeCustomer.customer_id + '_customer';
			for (let i = 0; i < items.length; i++) {
				this.newAttachments.push({
					folder: 'customer/' + owner_id,
					owner_type: owner_type,
					owner_id: owner_id,
					attachment_category_id: '',
					attachment_tags: tags,
					remark: '',
					file: items[i]
				});
			}
		},
		removeFile(file) {
			this.newAttachments = this.newAttachments.filter(item => {
				return item.file.upload.uuid != file.file.upload.uuid;
			});
		},
		uploadAll() {
			if (_gHlp.isEmpty(this.newAttachments)) return false
			this.is_loading_btn = true;
			let calls = [];
			for (let i = 0; i < this.newAttachments.length; i++) {
				const itm = this.newAttachments[i];
				let params = {};
				Object.keys(itm).forEach(key => {
					if (!_gHlp.isEmpty(itm[key])) {
						params[key] = itm[key];
					}
				});
				calls.push(this.uploadAttachment(params))
			}
			Promise.all(calls)
				.then(resp => {
					this.newAttachments = [];
					this.getListing();
					_gNotif.notifySuccess('<b>Cuatomer Documents:</b> - Successfully Uploaded.')
					this.is_loading_btn = false;
				})
				.catch(e => {
					this.is_loading_btn = false;
					_gNotif.errorFunction(e.message);
				})
		},
		deleteFile(attachment) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					this.deleteAttachment(attachment.attachment_id).then(resp => {
						this.getListing()
					})
				}
			});
		}
	}
}
</script>